class exports.Editkoz_Handler extends FullPageHandler

    init: () ->
        @sidebar_open = false
        @layoutUrl = 'backend/portal/editkoz/'
        @saveUrl = 'backend/portal/editkoz/save'
        @createDialog()

    afterLoadLayout: (selector, response) ->
        @openDialog()

        if response.status?.type isnt 'success'
            return

        @data = response.data
        @table = $('.handsontable')

        # Fix Size
        height = @dialog.find('.modal-body').height()
        @table.height(height + 'px')


        @data.kpo = $.map @data.kpo, (value, index) ->
            return [value]

        @table.handsontable
            data: @data.kpo,
            rowHeaders: @data.rowHeaders,
            colHeaders: @data.colHeaders,
            currentRowClassName: 'highlighted',
            currentColClassName: 'highlighted',
            columns: ({ data: 'hybrid' + id + '.kpo' } for id in @data.hybridIds )
            maxRows: @data.rowHeaders.length # Prevents adding new rows
            maxCols: @data.colHeaders.length # Prevents adding new cols
            beforeChange: (changes, source) ->
                for cell in changes

                    # Must be a number, must be an integer, must be finite, must between 0 and 1000
                    if isNaN(parseFloat(cell[3])) or not isFinite(cell[3]) or parseFloat(cell[3]) < 0 or parseInt(cell[3]) > 1000

                        return false
                    else if (parseFloat(cell[3]) is -0) or (parseFloat(cell[3]) is +0)
                        cell[3] = 0
                    else
                        col = cell[1].match(/.*[^.kpo]/)
                        @getSourceDataAtRow(cell[0])[col[0]].changed = true

                return true


        @dialog.find('.save-btn').bind 'click', () =>
            changedData = []

            for row in @data.kpo
                for key, cell of row
                    if cell.changed is true
                        changedData.push cell

            @saveData = kpo: JSON.stringify(changedData)
            @save('Saving K/Oz...')

        $(window).unbind('modal_resized').bind 'modal_resized', debounce (e) =>
            @resize()


    resize: () ->
        height = @dialog.find('.modal-body').height()
        @table.height(height + 'px')
